import { useLayoutEffect as e, useEffect as f } from "react";
const t = typeof document < "u" ? e : f;
export {
  t as useIsomorphicEffect
};
